DeviceSizes = {
    'screen-xs-min': 480,
    'screen-xs-max': 767 - 1,
    'screen-sm-min': 767,
    'screen-sm-max': 992 - 1,
    'screen-md-min': 992,
    'screen-md-max': 1200 - 1,
    'screen-lg-min': 1200
};

Device = {
    'screen-xs-min': 480,
    'screen-xs-max': 767 - 1,
    'screen-sm-min': 767,
    'screen-sm-max': 992 - 1,
    'screen-md-min': 992,
    'screen-md-max': 1200 - 1,
    'screen-lg-min': 1200,
    'breakpointMap': {
        'mobile': {'max': DeviceSizes['screen-xs-max']},
        'mobile-xs': {'max': DeviceSizes['screen-xs-min']},
        'non-mobile': {'min': DeviceSizes['screen-sm-min']},
        'tablet': {'max': DeviceSizes['screen-sm-max']},
        'tablet-landscape': {'max': DeviceSizes['screen-md-max']},
        'screen': {'min': DeviceSizes['screen-md-min']},
        'big-screen': {'min': DeviceSizes['screen-lg-min']}
    },
    breakpoint: function (point) {
        var map = this.breakpointMap[point];
        if (map) {
            if (window.matchMedia) {
                var queries = [];
                if (map.min) {
                    queries.push("(min-width: " + map.min + "px)");
                }
                if (map.max) {
                    queries.push("(max-width: " + map.max + "px)");
                }
                return window.matchMedia(queries.join(" and ")).matches;
            } else {
                if (map.min) {
                    if (jQuery(window).width() < map.min) {
                        return false;
                    }
                }
                if (map.max) {
                    if (jQuery(window).width() > map.max) {
                        return false;
                    }
                }
                return true;
            }
        }
    },
    isMobile: function() {
        return this.breakpoint('mobile');
    },
    isMobileXS: function() {
        return this.breakpoint('mobile-xs');
    },
    isTablet: function() {
        return this.breakpoint('tablet');
    },
    isTabletLandscape: function() {
        return this.breakpoint('tablet-landscape');
    },
    isScreen: function() {
        return this.breakpoint('screen');
    },
    isBigScreen: function() {
        return this.breakpoint('big-screen');
    }
};